<div class="login-page">
  <div class="hero-panel" aria-hidden="true">
    <div class="hero-copy">
      <p class="eyebrow">{{ 'login.eyebrow' | t }}</p>
      <h1>{{ appName }}</h1>
      <p>{{ 'passwordReset.forgotHero' | t }}</p>
    </div>
  </div>

  <div class="form-panel">
    <div class="lang-top">
      <app-language-switcher />
    </div>

    <form class="login-card ct-card" [formGroup]="form" (ngSubmit)="submit()">
      <div class="logo">
        <img [src]="logoUrl" [alt]="appName" />
        <div>
          <strong>{{ appName }}</strong>
          <small>{{ 'passwordReset.forgotTitle' | t }}</small>
        </div>
      </div>

      @if (sent()) {
        <p class="success">{{ 'passwordReset.sent' | t }}</p>
        <a class="back-link" routerLink="/login">{{ 'passwordReset.backToLogin' | t }}</a>
      } @else {
        <p class="hint">{{ 'passwordReset.forgotHint' | t }}</p>

        <div class="ct-field">
          <label for="email">{{ 'login.email' | t }}</label>
          <input
            id="email"
            class="ct-input"
            type="email"
            formControlName="email"
            autocomplete="username"
          />
          @if (form.controls.email.touched && form.controls.email.hasError('required')) {
            <small class="field-error">{{ 'passwordReset.emailRequired' | t }}</small>
          }
          @if (form.controls.email.touched && form.controls.email.hasError('email')) {
            <small class="field-error">{{ 'passwordReset.emailInvalid' | t }}</small>
          }
        </div>

        <button class="ct-btn ct-btn-navy login-btn" type="submit" [disabled]="submitting()">
          {{ 'passwordReset.sendLink' | t }}
        </button>

        @if (error()) {
          <p class="error">{{ error()! | t }}</p>
        }

        <a class="back-link" routerLink="/login">{{ 'passwordReset.backToLogin' | t }}</a>
      }
    </form>
  </div>
</div>
